<template>
    <div class="patsnap-biz-image_preview_dialog image-preview-dialog ai-common-ImagePreviewDialog">
        <div class="image-preview-main-area">
            <div class="image-preview-dialog-content">
                <img
                    ref="image"
                    class="patent-image"
                    :src="imageUrl"
                >
            </div>
            <div class="image-preview-arrow image-preview-left-arrow">
                <PtIcon
                    icon="SolidArrowLeft"
                    style="font-size: 14px"
                />
            </div>
            <div class="image-preview-arrow image-preview-right-arrow">
                <PtIcon
                    icon="SolidArrowRight"
                    style="font-size: 14px"
                />
            </div>
        </div>
        <div class="image-preview-title">
            {{ imageTitle }}
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { get } from 'lodash';
import PtIcon from '@patsnap-biz/icon';

export default {
    name: 'PtImagePreviewDialog',
    components: {
        PtIcon,
    },
    props: {
        descImage240List: {
            type: Object,
            default: () => ({}),
        },
        descImageList: {
            type: Object,
            default: () => ({}),
        },
        // eslint-disable-next-line vue/require-default-prop
        container: {
            type: Object,
            required: false,
        },
        containerSelector: {
            type: String,
            default: '',
        },
        anchorElement: {
            type: String,
            default: '',
        },
        isSimpleMode: {
            type: Boolean,
            default: false,
        },
        preProcessHook: {
            type: Function,
            default() { return true; },
        },
    },
    data() {
        return {
            imageUrl: '',
            imageTitle: '',
        };
    },
    mounted() {
        document.body.appendChild(this.$el);
        const $container = this.container || $(this.containerSelector);
        this.bindPreviewDialog($container, this.anchorElement, this.isSimpleMode);
    },
    beforeDestroy() {
        this.clearEvent();
        try {
            document.body.removeChild(this.$el);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
    },
    methods: {
        clearEvent() {
            if (this.$dialog) {
                this.$dialog.off();
            }
            if (this.$container) {
                const anchorSelector = this.anchorElement;
                this.$container
                    .off('mouseover', anchorSelector)
                    .off('mouseout', anchorSelector)
                    .off('click', anchorSelector);
            }
        },
        setImageAndTitle(imageId, imageTitle) {
            this.imageTitle = imageTitle;
            // eslint-disable-next-line max-len
            this.imageUrl = 'data:image/svg+xml;utf8,<svg height="32" width="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 10a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z"><animate attributeName="d" values="M20 10C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V13C21 13.2652 20.8946 13.5196 20.7071 13.7071C20.5196 13.8946 20.2652 14 20 14C19.7348 14 19.4804 13.8946 19.2929 13.7071C19.1054 13.5196 19 13.2652 19 13V11C19 10.7348 19.1054 10.4804 19.2929 10.2929C19.4804 10.1054 19.7348 10 20 10Z; M20 4C20.2652 4 20.5196 4.10536 20.7071 4.29289C20.8946 4.48043 21 4.73478 21 5V19C21 19.2652 20.8946 19.5196 20.7071 19.7071C20.5196 19.8946 20.2652 20 20 20C19.7348 20 19.4804 19.8946 19.2929 19.7071C19.1054 19.5196 19 19.2652 19 19V5C19 4.73478 19.1054 4.48043 19.2929 4.29289C19.4804 4.10536 19.7348 4 20 4Z; M20 10C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V13C21 13.2652 20.8946 13.5196 20.7071 13.7071C20.5196 13.8946 20.2652 14 20 14C19.7348 14 19.4804 13.8946 19.2929 13.7071C19.1054 13.5196 19 13.2652 19 13V11C19 10.7348 19.1054 10.4804 19.2929 10.2929C19.4804 10.1054 19.7348 10 20 10Z" begin="0.4s" dur="1s" repeatCount="indefinite"></animate></path><path d="M16 10a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z"><animate attributeName="d" values="M16 10C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11V13C17 13.2652 16.8946 13.5196 16.7071 13.7071C16.5196 13.8946 16.2652 14 16 14C15.7348 14 15.4804 13.8946 15.2929 13.7071C15.1054 13.5196 15 13.2652 15 13V11C15 10.7348 15.1054 10.4804 15.2929 10.2929C15.4804 10.1054 15.7348 10 16 10Z; M16 4C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8946 4.48043 17 4.73478 17 5V19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20C15.7348 20 15.4804 19.8946 15.2929 19.7071C15.1054 19.5196 15 19.2652 15 19V5C15 4.73478 15.1054 4.48043 15.2929 4.29289C15.4804 4.10536 15.7348 4 16 4Z; M16 10C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11V13C17 13.2652 16.8946 13.5196 16.7071 13.7071C16.5196 13.8946 16.2652 14 16 14C15.7348 14 15.4804 13.8946 15.2929 13.7071C15.1054 13.5196 15 13.2652 15 13V11C15 10.7348 15.1054 10.4804 15.2929 10.2929C15.4804 10.1054 15.7348 10 16 10Z" begin="0.3s" dur="1s" repeatCount="indefinite"></animate></path><path d="M12 10a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z"><animate attributeName="d" values="M12 10C12.2652 10 12.5196 10.1054 12.7071 10.2929C12.8946 10.4804 13 10.7348 13 11V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V11C11 10.7348 11.1054 10.4804 11.2929 10.2929C11.4804 10.1054 11.7348 10 12 10Z; M12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289C12.8946 4.48043 13 4.73478 13 5V19C13 19.2652 12.8946 19.5196 12.7071 19.7071C12.5196 19.8946 12.2652 20 12 20C11.7348 20 11.4804 19.8946 11.2929 19.7071C11.1054 19.5196 11 19.2652 11 19V5C11 4.73478 11.1054 4.48043 11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4Z; M12 10C12.2652 10 12.5196 10.1054 12.7071 10.2929C12.8946 10.4804 13 10.7348 13 11V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V11C11 10.7348 11.1054 10.4804 11.2929 10.2929C11.4804 10.1054 11.7348 10 12 10Z" begin="0.2s" dur="1s" repeatCount="indefinite"></animate></path><path d="M8 10a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1z"><animate attributeName="d" values="M8 10C8.26522 10 8.51957 10.1054 8.70711 10.2929C8.89464 10.4804 9 10.7348 9 11V13C9 13.2652 8.89464 13.5196 8.70711 13.7071C8.51957 13.8946 8.26522 14 8 14C7.73478 14 7.48043 13.8946 7.29289 13.7071C7.10536 13.5196 7 13.2652 7 13V11C7 10.7348 7.10536 10.4804 7.29289 10.2929C7.48043 10.1054 7.73478 10 8 10Z; M8 4C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5V19C9 19.2652 8.89464 19.5196 8.70711 19.7071C8.51957 19.8946 8.26522 20 8 20C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4Z; M8 10C8.26522 10 8.51957 10.1054 8.70711 10.2929C8.89464 10.4804 9 10.7348 9 11V13C9 13.2652 8.89464 13.5196 8.70711 13.7071C8.51957 13.8946 8.26522 14 8 14C7.73478 14 7.48043 13.8946 7.29289 13.7071C7.10536 13.5196 7 13.2652 7 13V11C7 10.7348 7.10536 10.4804 7.29289 10.2929C7.48043 10.1054 7.73478 10 8 10Z" begin="0.1s" dur="1s" repeatCount="indefinite"></animate></path><path d="M4 10a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1z"><animate attributeName="d" values="M4 10C4.26522 10 4.51957 10.1054 4.70711 10.2929C4.89464 10.4804 5 10.7348 5 11V13C5 13.2652 4.89464 13.5196 4.70711 13.7071C4.51957 13.8946 4.26522 14 4 14C3.73478 14 3.48043 13.8946 3.29289 13.7071C3.10536 13.5196 3 13.2652 3 13V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10Z; M4 4C4.26522 4 4.51957 4.10536 4.70711 4.29289C4.89464 4.48043 5 4.73478 5 5V19C5 19.2652 4.89464 19.5196 4.70711 19.7071C4.51957 19.8946 4.26522 20 4 20C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V5C3 4.73478 3.10536 4.48043 3.29289 4.29289C3.48043 4.10536 3.73478 4 4 4Z; M4 10C4.26522 10 4.51957 10.1054 4.70711 10.2929C4.89464 10.4804 5 10.7348 5 11V13C5 13.2652 4.89464 13.5196 4.70711 13.7071C4.51957 13.8946 4.26522 14 4 14C3.73478 14 3.48043 13.8946 3.29289 13.7071C3.10536 13.5196 3 13.2652 3 13V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10Z" dur="1s" repeatCount="indefinite"></animate></path></svg>';
            const tempImageUrl = get(this.descImageList, `[${imageId}].url`);
            $(this.$refs.image).one('load', () => {
                this.imageUrl = tempImageUrl;
            });
        },
        bindPreviewDialog($container, anchorElement, isSimpleMode) {
            // eslint-disable-next-line no-underscore-dangle
            const _this = this;
            let timer;
            let imageList = null;
            let imageIndex = -1;
            const imagePanelData = {
                index: 0,
                list: [],
                total: 1,
                type: 'image',
            };
            const $dialog = $(this.$el);
            const $left = $dialog.find('.image-preview-left-arrow');
            const $right = $dialog.find('.image-preview-right-arrow');
            const anchorSelector = anchorElement || 'a.see-img-anchor';
            this.$container = $container;
            this.$dialog = $dialog;

            this.clearEvent();

            $container.on('mouseover', anchorSelector, function named() {
                clearTimeout(timer);
                const obj = $(this);
                let imageId = obj.attr('img-id');
                let imageTitle = obj.attr('img-title');
                const imageIds = imageId && imageId.split(',');
                imagePanelData.list = [];
                imagePanelData.index = 0;
                if (imageIds && imageIds.length > 1) {
                    // multiply image
                    imageTitle = imageTitle && imageTitle.split(',');
                    imageList = [];
                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < imageIds.length; i++) {
                        imageList.push({
                            imageId: imageIds[i],
                            imageTitle: imageTitle[i],
                        });
                        imagePanelData.list.push({
                            src: get(_this.descImageList, `[${imageIds[i]}].url`),
                            path: get(_this.descImage240List, `[${imageIds[i]}].url`),
                        });
                    }
                    imagePanelData.total = imagePanelData.list.length;
                    imageIndex = 0;
                    imageId = get(imageList, `[${imageIndex}].imageId`);
                    imageTitle = get(imageList, `[${imageIndex}].imageTitle`);
                    $right.show();
                    $left.hide();
                } else {
                    $right.hide();
                    $left.hide();
                    imagePanelData.list.push({
                        src: get(_this.descImageList, `[${imageId}].url`),
                        path: get(_this.descImage240List, `[${imageId}].url`),
                    });
                }
                imagePanelData.total = imagePanelData.list.length;

                _this.setImageAndTitle(imageId, imageTitle);
                const offset = obj.offset();
                // eslint-disable-next-line no-underscore-dangle
                const _width = obj.width();
                // eslint-disable-next-line no-underscore-dangle
                const _height = obj.height();
                const dialogWidth = 362;
                const dialogHeight = 324;
                if (_this.preProcessHook(imageIds, 'mouseover') === false) { return; }
                // Set hover div position
                if (window.innerWidth - offset.left - _width <= dialogWidth) {
                    // left
                    if (window.innerHeight - offset.top < dialogHeight) {
                        // top
                        $dialog.css({
                            left: offset.left - dialogWidth,
                            top: offset.top - dialogHeight + _height,
                            position: 'absolute',
                        }).show();
                    } else {
                        // bottom
                        $dialog.css({
                            left: offset.left - dialogWidth,
                            top: offset.top,
                            position: 'absolute',
                        }).show();
                    }
                } else {
                    // right
                    // eslint-disable-next-line no-lonely-if
                    if (window.innerHeight - offset.top < dialogHeight) {
                        // top
                        $dialog.css({
                            left: offset.left + _width,
                            top: offset.top - dialogHeight + _height,
                            position: 'absolute',
                        }).show();
                    } else {
                        // bottom
                        $dialog.css({
                            left: offset.left + _width,
                            top: offset.top,
                            position: 'absolute',
                        }).show();
                    }
                }
            }).on('mouseout', anchorSelector, () => {
                timer = setTimeout(() => {
                    $dialog.hide();
                }, 500);
            }).on('click', anchorSelector, function named() {
                const obj = $(this);
                const imageId = obj.attr('img-id');
                const imageIds = imageId && imageId.split(',');
                if (_this.preProcessHook(imageIds, 'click') === false) { return; }
                _this.$emit('showImagePanel', imagePanelData);
            });

            $dialog.find('.image-preview-title').show();

            $dialog.on('mouseover', () => {
                clearTimeout(timer);
            }).on('mouseout', () => {
                timer = setTimeout(() => {
                    $dialog.hide();
                }, 500);
            });

            if (isSimpleMode) {
                $dialog.find('.image-preview-title').hide();
                return;
            }

            $dialog.on('click', '.image-preview-left-arrow', (e) => {
                e.stopPropagation();
                if (imageIndex < 1) {
                    return;
                }
                // eslint-disable-next-line no-plusplus
                imageIndex--;
                _this.setImageAndTitle(imageList[imageIndex].imageId, imageList[imageIndex].imageTitle);
                $right.show();
                if (imageIndex === 0) {
                    $left.hide();
                }
            })
                .on('click', '.image-preview-right-arrow', (e) => {
                    e.stopPropagation();
                    if (imageIndex + 1 >= imageList.length) {
                        return;
                    }
                    // eslint-disable-next-line no-plusplus
                    imageIndex++;
                    _this.setImageAndTitle(imageList[imageIndex].imageId, imageList[imageIndex].imageTitle);
                    $left.show();
                    if (imageIndex + 1 === imageList.length) {
                        $right.hide();
                    }
                })
                .on('click', '.image-preview-main-area', () => {
                    _this.$emit('showImagePanel', imagePanelData);
                });
        },
    },
};
</script>
